import { CODE } from 'domains/product-attribute/constants'
import { DISCOUNT_FOR, SHIPMENT_DISCOUNT_TYPE, ITEM_DISCOUNT_TYPE } from '../constants/voucher-constants'

// Provide services for Voucher
const VoucherService = {

  /**
   * Generate voucher Code based on the format that users input.
   *
   * @param {number} length - Code length
   * @param {string} format - Code format
   * @param {string} prefix - Code prefix
   * @param {string} suffix - Code suffix
   * @param {number} dashEveryXChar - Number of dash generated of code
   */
  generateCode: (length, format, prefix = '', suffix = '', dashEveryXChar = 0) => {
    let result     = ''
    let characters = ''

    switch (format) {
      case 'alphanumeric':
        characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
        break
      case 'alphabetical':
        characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        break
      case 'numeric':
        characters = '0123456789'
        break
      default:
        characters = ''
    }

    let charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      if (dashEveryXChar > 0 && (i + 1) % dashEveryXChar === 0) result += '-'
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return prefix + result + suffix
  },

  /**
   * Format JSON object to FormData
   *
   * @param {object} obj - JSON object
   * @param {FormData} form - Form data
   * @param {string} namespace - Form data namespace
   * @param {boolean} isArray - To know if the child is an array object
   */
  toFormData: (obj, form, namespace, isArray = false) => {
    let fd = form || new FormData()
    let formKey

    for (let property in obj) {
      if (namespace) {
        if (isArray) {
          formKey = namespace + '[]'
        } else {
          formKey = namespace + '[' + property + ']'
        }
      } else {
        formKey = property
      }
      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString())
      }
      else if (obj[property] instanceof Array) {
        VoucherService.toFormData(obj[property], fd, formKey, true)
      }
      else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        VoucherService.toFormData(obj[property], fd, formKey)
      } else { // if it's a string or a File object
        fd.append(formKey, obj[property])
      }
    }

    return fd
  },

  /**
   * Before sending the value to the backend, we convert array type attribute value to the string with comma delimiter
   * @param {object} values - Values from formikbag
   */
  convertAttributeValuesArray: (values = {}) => {
    const { conditions: { product_attributes, cart_attributes } } = values

    let convertedProductAttributes = []
    let convertedCardAttributes    = []

    product_attributes.forEach((attribute) => {
      convertedProductAttributes.push({
        ...attribute,
        value: Array.isArray(attribute.value) ? attribute.value.join(',') : attribute.value
      })
    })

    cart_attributes.forEach((attribute) => {
      convertedCardAttributes.push({
        ...attribute,
        value: Array.isArray(attribute.value) ? attribute.value.join(',') : attribute.value
      })
    })

    return {
      ...values,
      conditions: {
        product_attributes : convertedProductAttributes,
        cart_attributes    : convertedCardAttributes
      }
    }
  },

  /**
   * Reverse string with comma delimiter attribute value to Array type
   * To be able used in the domain field
   * @param {object} values - Voucher rule response API
   */
  reverseAttributeValuesArray: (values = {}) => {
    const { conditions: { product_attributes, cart_attributes } } = values

    let convertedProductAttributes = []

    product_attributes.forEach((attribute) => {
      const { code, value } = attribute

      // TODO: we might want to add more code for multiple value later
      // * For collection attribute, it already string from the domain field so we won't convert it
      if ([ CODE.COLOUR ].includes(code)) {
        convertedProductAttributes.push({
          ...attribute,
          value: value.includes(',') ? attribute.value.split(',').map((x) => parseInt(x)) : value
        })
      }
      else {
        convertedProductAttributes.push(attribute)
      }
    })

    return {
      ...values,
      conditions: {
        product_attributes : convertedProductAttributes,
        cart_attributes    : cart_attributes
      }
    }
  },

  isDiscountAbsolute: (voucher, discountFor) => {
    if (discountFor === DISCOUNT_FOR.ITEM) return voucher.rule.item_discount_type === ITEM_DISCOUNT_TYPE.ABSOLUTE

    if (discountFor === DISCOUNT_FOR.SHIPMENT) return voucher.rule.shipment_discount_type === SHIPMENT_DISCOUNT_TYPE.ABSOLUTE
  },

  isDiscountPercentage: (voucher, discountFor) => {
    if (discountFor === DISCOUNT_FOR.ITEM) return voucher.rule.item_discount_type === ITEM_DISCOUNT_TYPE.PERCENTAGE

    if (discountFor === DISCOUNT_FOR.SHIPMENT) return voucher.rule.shipment_discount_type === SHIPMENT_DISCOUNT_TYPE.PERCENTAGE
  },

  isDiscountActive: (voucher, discountFor) => {
    if (discountFor === DISCOUNT_FOR.ITEM) return voucher.rule.is_item_discount_active

    if (discountFor === DISCOUNT_FOR.SHIPMENT) return voucher.rule.is_shipment_discount_active
  }

}

export default VoucherService
